import Address from './Address';
import Courier from './Courier';
import Item from './Item';
import Price from './Price';
import Status from './Status';
import Time from './Time';

export default {
    Address,
    Courier,
    Item,
    Price,
    Status,
    Time
}